<template>
    <div>
        <md-cell-item>
            <div slot="left" class="intrust-item">
                <div class="batchd">
                    <pointtext type="batch" :text="order.orderno"></pointtext>
                </div>
                <div class="price">
                    <span class="price-text">Selling price</span>
                    ₹
                    <md-amount class="amount"
                        :value="Number(order.amount)"
                        has-separator
                    ></md-amount>
                </div>
                <div class="price">
                    <span class="price-text">Quantity</span>
                    <md-amount class="amount"
                        :value="Number(order.amount)"
                        has-separator
                    ></md-amount> IToken
                </div>
                <div class="price">
                    <span class="price-text">Deal Date</span>
                    <span>{{ order.ctime }}</span>
                </div>
                <div class="completion">
                    <pointtext type="success" text="success" v-if="order.collection_status==='success'"></pointtext>
                    <pointtext type="paying" text="paying" v-if="order.collection_status==='dispatched'"></pointtext>
                    <pointtext type="notline" text="timeout" v-if="order.collection_status==='timeout'"></pointtext>
                </div>
            </div>
            <div slot="right">
                <span slot="right" @click="showdetail(order.id)">Detail</span>
            </div>

        </md-cell-item>

        <md-dialog
            class="detail"
            :title="order.orderno"
            :closable="false"
            v-model="detailopen"
            :btns="btns"
        >
            <md-field>
                <md-detail-item title="UPI ID" :content="order.collection_upi_id" bold />
                <md-detail-item title="Kyc Partner" :content="order.ct_type" />
                <md-detail-item title="Debit time" :content="order.ctime" />
                <md-detail-item title="Deal time" :content="order.mtime" />
                <md-detail-item title="Utr" :content="get_utr(order.upi_ref_no)" />
                <md-detail-item title="Order status" :content="get_order_status(order.status)" />
                <md-detail-item title="Transaction detail" bold>
                    <a href="javascript:;" style="color:#5878B4;text-decoration:none;" @click="check_detai">Check</a>
                </md-detail-item>
                <div v-if="check">
                    <div v-for="i in detail" v-bind:key="i.id">
                        <md-detail-item class="detail-title" :title="i.type" :content="i.amount + ' IToken'" />
                        <md-detail-item :content="i.remark" />
                    </div>
                </div>
                <md-detail-item title="Dispute about order" bold v-if="order.orderno.startsWith('FL')">
                    <a href="javascript:;" style="color:#5878B4;text-decoration:none;" @click="revieworder">Re-Audit</a>
                </md-detail-item>
            </md-field>
        </md-dialog>

        <md-dialog title="Apply for Re-Audit" :closable="true" v-model="revieworderdialog.open" :btns="revieworderdialog.btns">
			<md-radio-list :options="review_reasons_options" v-model="review_reasons" icon="right" icon-inverse="" icon-disabled=""
				icon-position="right" has-input input-label="Other" input-placeholder="Please enter a reason" />
		</md-dialog>

    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { getassetsrecord, billlockquotareview } from '@/request/api'

export default {
    name: 'sellhistoryitem',
    props: {
        order: {
            type: Object,
            default: {}
        }
    },
    components: {
        iconimg,
        pointtext
    },
    data() {
        return {
            detailopen: false,
            btns: [
                {
                    text: 'Close',
                },
            ],
            check: false,
            detail: [],
            revieworderdialog: {
				open: false,
				btns: [
					{
						text: 'Cancel',
						handler: this.onDialogCancel,
					},
					{
						text: 'Submit',
						handler: this.onDialogConfirm,
					},
				],
			},
            review_reasons_options: [
				{ value: 'this is a private transfer', text: 'this is a private transfer' },
				{ value: "I didn't receive this payment", text: "I didn't receive this payment" },
			],
            review_reasons: "this is a private transfer"
        }
    },
    created() {
    },

    methods: {
        revieworder() {
			this.revieworderdialog.open = true;
		},
        onDialogCancel() {
			this.revieworderdialog.open = false;
		},
        onDialogConfirm() {
            // submit re-audit
            if(this.review_reasons.length < 6) {
                this.$toast.failed("pls inter re-audit reasons");
                return
            }
            billlockquotareview({
                id: this.order.id,
                audit_reference: this.review_reasons
            }).then(res=>{
                if(res.code === 200) {
                    this.$toast.succeed("Submit re-audit success");
                    this.revieworderdialog.open = false;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
		},
        showdetail(){
            this.detailopen = true;
        },
        get_utr(utr) {
            if(utr === '' || !utr) {
                return 'NA';
            } else {
                return utr;
            }
        },
        get_check_title(type, amount) {
            return type.charAt(0).toUpperCase() + type.slice(1) + " " + amount + " IToken";
        },
        get_order_status(status) {
            if(status === 'success') {
                return 'Success'
            }
            if(status === 'dispatched') {
                return 'Pending'
            }
            if(status === 'timeout') {
                return 'Timeout'
            }
            if(status === 'fail') {
                return 'Fail'
            }
            if(status === 'undispatched') {
                return 'Wait'
            }
            return 'Pending'
        },
        check_detai() {
            this.$toast.loading("Loading...");
            let filter_params = {}
            if(this.order.orderno.startsWith("FL")) {
                filter_params = {
                    utr: this.order.upi_ref_no
                }
            } else {
                filter_params = {
                    orderno: this.order.orderno
                }
            }
            getassetsrecord(filter_params).then(res=>{
                this.$toast.hide();
                if(res.code === 200) {
                    this.detail = res.data.result;
                    this.check = true;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        }
    }
}

</script>
<style scoped>
.intrust-item {
    font-size: 0.26rem;
}
.intrust-item >>> .batch {
    color: black;
}

.intrust-item .batchd {
    margin-left: -9px;
}

.intrust-item .completion {
    margin-left: -0.19rem;
}

.intrust-item .price {
    color: black;
    font-size: 0.3rem;
}
.intrust-item .price .price-text {
    color: #2c3e50;
    font-size: 0.2rem;
}
.intrust-item .price .amount {
    font-weight: 200;
    font-size: 0.3rem;
}
.intrust-item div {
    margin: 4px;
}

.detail >>> .md-dialog-title {
    color: #01080f;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 400;
    line-height: 1.2;
    margin: 0.3rem 0.28rem;
}

.detail >>> .md-dialog-body {
    color: #666f83;
    font-size: 0.28rem;
    text-align: left;
    padding: 0.12rem 0.22rem !important;
}

.detail-title >>> .md-detail-title {
    color: red;
    font-size: 0.32rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/sellhistoryitem.vue